import React, { useState, useRef, useEffect } from 'react';
import "./topSearchBar.css";
import logo from '../../../assets/logo.png';
import { ChevronDown, Search } from 'lucide-react';


const styles = {
    container: {
        position: 'relative',
        width: '100%',
        maxWidth: '500px',
    },
    searchBar: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '4px',
        backgroundColor: 'white',
    },
    input: {
        flex: 1,
        border: 'none',
        outline: 'none',
        padding: '0 8px',
    },
    buttonGroup: {
        display: 'flex',
        gap: '8px',
    },
    button: {
        padding: '4px 8px',
        backgroundColor: '#f0f0f0',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dropdown: {
        position: 'absolute',
        top: '100%',
        width: '100%',
        left: 0,
        right: 0,
        marginTop: '4px',
        backgroundColor: 'white',
        border: '1px solid #ddd',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 1000,
    },
    list: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
    },
    listItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
    },
    checkbox: {
        margin: 0,
    },
    hoverEffect: {
        ':hover': {
            backgroundColor: '#f5f5f5',
        }
    }
};

const TopSearchBars = ({ onSelect }) => {
    const [search, setSearch] = useState('');
    const [firstSearch, setFirstSearch] = useState('');

    const [isOpen, setIsOpen] = useState(false);
    const [isFirstOpen, setIsFirstOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState(new Set([
        "Annual Report",
        "Quarterly Report",
        "Earnings Call",
        "Financial Subsidiaries",
        "Shareholding Pattern",
        "Corporate Governance",
        "ESG Report",
        "CSR Report",
    ]));

    const [allSuggestions, setAllSuggestions] = useState([]);

    const items = [
        "Annual Report",
        "Quarterly Report",
        "Earnings Call",
        "Financial Subsidiaries",
        "Shareholding Pattern",
        "Corporate Governance",
        "ESG Report",
        "CSR Report",
    ];
    const dropdownRef = useRef(null);

    const apiUrl = "https://linklogic-backend.vercel.app/api/list";





    useEffect(() => {
        const fetchData = async () => {
            try {

                const response = await fetch(apiUrl);
                if (!response.ok) throw new Error("Network response was not ok");
                const data = await response.json();
                setAllSuggestions(data);

            } catch (error) {
                console.error("Fetch error:", error);
            }
        };

        fetchData();
    }, [apiUrl]); // Runs when apiUrl changes


    const filteredSuggestions = allSuggestions.filter(item =>
        item.name.toLowerCase().includes(search.toLowerCase())
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setIsFirstOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setIsOpen(true);
    };

    const handleSelect = (name, category) => {
        setSearch(name);
        setFirstSearch('');
        setIsOpen(false);
        onSelect(name, category);
    };

    const handleFirstSearch = (name, category) => {
        setFirstSearch(name);
        setSearch('');
        onSelect(category, 'Document');
    };

    const toggleItem = (item) => {
        const newSelected = new Set(selectedItems);
        if (newSelected.has(item)) {
            newSelected.delete(item);
        } else {
            newSelected.add(item);
        }
        setSelectedItems(newSelected);
    };




    return (
        <div className="top-search-bars">
            {/* Image at the left */}
            <img
                src={logo}
                alt="Search Icon"
                className="search-image"
            />

            {/* First Search Bar */}


            {/* Second Search Bar with Suggestions */}
            <div ref={dropdownRef} style={{
                position: 'relative',
                width: '100%',
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    padding: '4px'
                }}>
                    <input
                        type="text"
                        value={search}
                        onChange={handleSearch}
                        onFocus={() => setIsOpen(true)}
                        placeholder="Search for company or sector..."
                        style={{
                            flex: 1,
                            border: 'none',
                            outline: 'none',
                            padding: '0 8px'
                        }}
                    />
                    <button style={{
                        padding: '6px 8px',
                        backgroundColor: '#f0f0f0',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <Search size={15} color="#666" />
                    </button>

                </div>

                {isOpen && search.length > 0 && filteredSuggestions.length > 0 && (
                    <ul style={{
                        position: 'absolute',
                        top: '100%',
                        width: '100%',
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        marginTop: '4px',
                        padding: '0',
                        listStyle: 'none',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        zIndex: 1000
                    }}>
                        {filteredSuggestions.map((item, index) => (
                            <li
                                key={index}
                                onClick={() => handleSelect(item.name, item.category)}
                                style={{
                                    padding: '8px',
                                    cursor: 'pointer',
                                    borderBottom: index === filteredSuggestions.length - 1 ? 'none' : '1px solid #eee',
                                    position: 'relative',
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5'
                                    }
                                }}
                            >
                                <div style={{ textAlign: 'left' }}>{item.name}</div>
                                <div style={{
                                    position: 'absolute',
                                    right: '8px',
                                    bottom: '4px',
                                    fontSize: '12px',
                                    color: '#666'
                                }}>
                                    {item.category}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default TopSearchBars;
